import { render, staticRenderFns } from "./ProductAddViewModal.vue?vue&type=template&id=645a1190&"
import script from "./ProductAddViewModal.vue?vue&type=script&lang=js&"
export * from "./ProductAddViewModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddViewModal.vue?vue&type=style&index=0&id=645a1190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports